var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-xs text-wrap font-normal leading-[16.94px]",class:{
    'text-[#16a249]': _vm.item.isSuccessful && _vm.item.isRegistered,
    'text-[#EF5253]': !_vm.item.isSuccessful,
    'text-[#FD881E]': _vm.item.isSuccessful && !_vm.item.isRegistered
}},[_vm._v(" "+_vm._s(_vm.shortenedMessage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }